import { Granularity } from "@/API";
import { Stat } from "@/entities";
import { ISaleStatRepository } from "@/repositories";
import { mini } from "@/settings/branchs";
import dayjs from 'dayjs'
import { IAdminStatService } from ".";

export class AdminStatService implements IAdminStatService {
    constructor(private repository: ISaleStatRepository) { }
    async listDailyStat(inputDate: Date): Promise<Stat[] | undefined> {
        const branchList = mini();

        branchList.push({
            name: 'ALL',
            code: 'ALL',
        });

        console.log("branchList",branchList);

        let list: Stat[] = [];
        if (!inputDate) {
            throw new Error("No inputDate parameter.");
        }

        const input = dayjs(inputDate)

        const param = {
            eq: { granularity: Granularity.DAILY, timestamp: input.unix() }
        };

        await Promise.all(branchList.map(async (b) => {
            let temp: Stat[] = [];
            let token: string | undefined;
            do {
                const { items, nextToken } = await this.repository.getSaleStat(b.code, param, token)
                // console.log(items, nextToken);
                if (items) {
                    const l = items.map((i: any) => new Stat(i));
                    temp = [...temp, ...l];
                }
                token = nextToken;
            }
            while (token);
            list = [...list, ...temp];
        }));
        // console.log(list);
        return list;
    }
    async listWeeklyStat(inputWeek: Date): Promise<Stat[] | undefined> {
        const branchList = mini();
        branchList.push({
            name: 'ALL',
            code: 'ALL',
        });
        let list: Stat[] = [];
        if (!inputWeek) {
            throw new Error("No inputWeek parameter.");
        }

        const input = dayjs(inputWeek);
        console.log(input.startOf('week'), input.startOf('week').unix());

        const param = {
            eq: { granularity: Granularity.WEEKLY, timestamp: (input.startOf('week').unix()) }
        };

        await Promise.all(branchList.map(async (b) => {
            let temp: Stat[] = [];
            let token: string | undefined;
            do {
                const { items, nextToken } = await this.repository.getSaleStat(b.code, param, token)
                // console.log(items, nextToken);
                if (items) {
                    const l = items.map((i: any) => new Stat(i));
                    temp = [...temp, ...l];
                }
                token = nextToken;
            }
            while (token);
            list = [...list, ...temp];
        }));
        // console.log(list);
        return list;
    }
    async listMonthlyStat(inputMonth: Date): Promise<Stat[] | undefined> {
        const branchList = mini();
        branchList.push({
            name: 'ALL',
            code: 'ALL',
        });
        let list: Stat[] = [];
        if (!inputMonth) {
            throw new Error("No inputDate parameter.");
        }

        const input = dayjs(inputMonth)

        const param = {
            eq: { granularity: Granularity.MONTHLY, timestamp: input.unix() }
        };

        await Promise.all(branchList.map(async (b) => {
            let temp: Stat[] = [];
            let token: string | undefined;
            do {
                const { items, nextToken } = await this.repository.getSaleStat(b.code, param, token)
                // console.log(items, nextToken);
                if (items) {
                    const l = items.map((i: any) => new Stat(i));
                    temp = [...temp, ...l];
                }
                token = nextToken;
            }
            while (token);
            list = [...list, ...temp];
        }));
        // console.log(list);
        return list;
    }
    async refrehsDailyStat(): Promise<void> {
        return this.repository.refreshDailyStat();
    }
}